export default __webpack_public_path__ + "static/media/down_arrow_icon_filled.2d38ece1.svg";